export default __webpack_public_path__ + "static/media/arrow-left-blue-icon.ec501fec.svg";